<template>
	<page>
		<module enable-flex>
			<m-search ref="search" fold :extend-field="columnList" @search="searchHandle">
				<m-search-item label="计价方式">
					<c-select name="pricing_types" :options="pricingTypeDic" multiple></c-select>
				</m-search-item>
				<m-search-item label="状态">
					<c-select name="states" :options="disableEnableDic" multiple></c-select>
				</m-search-item>
				<m-search-item label="创建时间">
					<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
				</m-search-item>
				<m-search-item label="工资单价">
					<c-input type="number" range name="query_price" decimal="6"></c-input>
				</m-search-item>
			</m-search>

			<m-operate :batch="batchData.length" @batchCancel="batchCancel">
				<c-button color="main" v-if="auth('b_salary_match_config_add')" v-lock="lock('b_salary_match_config_add')" prepend-icon="tf-add" @click="$refs.salaryConfigEdit.open()">新增绩效工资配置</c-button>
				<c-button v-if="auth('b_salary_match_rule_config')" v-lock="lock('b_salary_match_rule_config')" @click="$refs.salaryRuleConfig.open()">匹配规则配置</c-button>
				<c-button v-if="auth('b_salary_match_config_add')" v-lock="lock('b_salary_match_config_add')" prepend-icon="tf-import" @click="excelImport()">导入</c-button>

				<template #batch>
					<c-button v-if="auth('b_salary_match_config_remove')" v-lock="lock('b_salary_match_config_remove')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemove">删除</c-button>
				</template>

				<template #right>
					<c-button v-if="auth('b_salary_match_config_log')" v-lock="lock('b_supplier_log')" hollow prepend-icon="tf-import-record" @click="loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_salary_match_config_log')" v-lock="lock('b_salary_match_config_log')" prepend-icon="tf-operate-record" @click="loadWorkLogDetail()">操作记录</c-button>
				</template>
			</m-operate>

			<c-table ref="list" border height="grow" width-resize>
				<c-table-column
					type="selector"
					width="32"
					@handle="batchSelect"
				></c-table-column>

				<!-- <c-table-column
					label="编号"
					name="id"
					width="50"
				>
				</c-table-column> -->

				<c-table-column
					label="计价方式"
					name="pricing_type"
					width="70"
				>
					<template #default="{data}">
						<c-state dict="pricingTypeDic" :value="data.pricing_type"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="工资单价"
					name="price"
					width="75"
				>
					<template #default="{data}">
						<span>¥{{data.price}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="标准产出"
					name="unit_duration_count"
					width="70"
				>
				</c-table-column>

				<c-table-column
					label="标准工时"
					name="unit_duration_time"
					width="100"
				>
					<template #default="{data}">
						<span v-if="data.unit_duration_time">{{data.unit_duration_time}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<template v-for="(col, i) in columnList">
					<template>
						<c-table-column
							:key="i"
							:label="col.field_title"
							:name="col.field_code"
							:width="calColumWidth(col)"
						>
							<template #default="{data}">
								<c-tags v-if="data[col.field_code] && (col.field_type == 4||col.field_type == 9)" :value="data[col.field_code].split(',')"></c-tags>
								<span v-else>{{data[col.field_code]}}</span>
							</template>
						</c-table-column>
					</template>
				</template>

				<c-table-column
					label="状态"
					name="state"
					width="80"
				>
					<template #default="{data}">
						<c-switch v-if="auth('b_salary_match_config_edit')" v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="排序"
					type="sort"
					@handle="sortHandle">
				</c-table-column>
		
				<c-table-column
					label="备注"
					name="remark"
					width="120"
				>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="155"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_salary_match_config_edit')" v-lock="lock('b_salary_match_config_edit')" icon="tf-edit" @click="$refs.salaryConfigEdit.open(data,2)">编辑</c-table-button>
						<c-table-button v-if="auth('b_salary_match_config_edit')" v-lock="lock('b_salary_match_config_edit')" icon="tf-copy" @click="$refs.salaryConfigEdit.open(data,3)">复制</c-table-button>
						<c-table-button v-if="auth('b_salary_match_config_remove')" v-lock="lock('b_salary_match_config_remove')" icon="tf-trash" color="red" @click="remove(data)">删除</c-table-button>
					</template>
				</c-table-column>

			</c-table>
			<!--新增/编辑配置弹窗-->
			<salary-config-edit ref="salaryConfigEdit"></salary-config-edit>
			<!--配置规则弹窗-->
			<salary-rule-config ref="salaryRuleConfig"></salary-rule-config>
		</module>
	</page>
</template>
<script>
import {mapState} from 'vuex'
import salaryConfigEdit from "@/pages/basic/salary_match_config_edit.vue";
import salaryRuleConfig from "@/pages/basic/salary_rule_config.vue";
import {batchData, batchMethods} from '@/components/public/batch.js'

export default {
	name: 'salary_match_config',
	components: {salaryConfigEdit,salaryRuleConfig},

	data() {
		return {
			...batchData(),
			workType:31,
			columnList: [],
			min_price:null,
			max_price:null
		}
	},

	computed: {
		// 获取dictName选项数据
		...mapState(['disableEnableDic','pricingTypeDic']),
	},

	mounted() {
		//加载表格列头信息
		this.updateColumn();
		//执行搜索方法
		this.searchHandle();

		this.$bus.$on('salary_match_config.list.update', data => {
			// 刷新列表
			this.loadDataList();
		});
		this.$bus.$on('salary_match_config.field.update', data => {
			// 刷新列表
			this.updateColumn();
		});
	},

	methods: {
		...batchMethods(),
		
		/********搜索************/
		searchHandle(data){
			this.flterParams = data||{};
			this.loadDataList();
		},

		//更新表头数据
		updateColumn() {
			this.request({
				url: '/salary/match/config/field_list',
				data: {},
				success: data => {
					this.columnList = [];
					this.$nextTick(() => {
						this.columnList = data;
					});
				}
			});
		},

        //计算列宽
        calColumWidth(data){
            var width = 100;
            if (data.field_title == '工序名称'){
                width = 120;
            }else if (data.field_title == '生产人员'){
                width = 120;
            }else if (data.field_title == '产品'){
                width = 200;
            }else if (data.field_title == '备注'){
                width = 150;
            }else if (data.field_type == 4){//选项
                width = 120;
            }else if (data.field_type == 3){//时间
                width = 140;
            }
            return width;
        },

		//查询数据列表
		loadDataList(){
			this.$refs.list.load({
				url:'/salary/match/config/list',
				data:this.flterParams,
				success: () => {
					this.batchData = [];
				}
			});
		},

		/******启禁用*********/
		stateHandle(state, next, data) {
			this.request({
				url: '/salary/match/config/state/edit',
				data: {
					id: data.id,
					state: state ? 2 : 1
				},
				success: () => {
					next();
					this.$message({
						message:(state==1?'禁用':'启用')+'成功',  // 提示内容,
						type: 'success'
					});
				}
			});
		},

		/********************排序**************************/
		sortHandle(row, type, next) {
			this.request({
				url: '/salary/match/config/sort',
				data: {
					id: row.data.id,
					type: ['top', 'bottom'].includes(type) ? type : '',
					id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
					id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
				},
				loading: true,
				success: data => {
					next();
				}
			});
		},

		/****批量删除行数据***/
		batchRemove(){
			var ids = [];
			this.$refs.list.getData('selected').forEach(item => {
				ids.push(item.id);
			});
			
			this.$confirm({
				message:'确认删除' + ids.length + '条绩效工资配置记录吗？删除后不可恢复',  // 提示内容,
				buttonName: '确定',  // 确定按钮文字
				cancelButton: true,  // 是否显示取消按钮
				resolve: () => {
					this.request({
						url: '/salary/match/config/remove/batch',
						data: {ids: ids},
						loading: true,
						success: data => {
							let Mtype = 'success';
							let message = '成功' + data.success_count + '条';
							if(data.fail_count > 0 && data.success_count > 0){
								Mtype = 'warn';
								message += '，失败'+data.fail_count+'条';
							}else if(data.fail_count > 0 && data.success_count == 0){
								Mtype = 'fail'
								message += '，失败'+data.fail_count+'条';
							}else{
								message = '成功删除' + data.success_count + '条记录';
							}
							this.$message({
								message: message,  // 提示内容,
								type: Mtype
							});
							//刷新
							this.$refs.list.update();
						}
					});
				},  // 确定按钮回调
				cancel: () => {},  // 取消按钮回调
			});
		},

		/*******删除行数据*****************/
		remove(data){
			// 确认弹窗
			this.$confirm({
				title: '删除警告',
				message: '确认删当前绩效工资配置？删除后不可恢复，请谨慎操作',
				resolve: () => {
					this.request({
						url: '/salary/match/config/remove',
						data: {
							id: data.id
						},
						success: () => {
							this.$message({
								message:'删除成功',  // 提示内容,
								type: 'success'
							});
							//刷新列表
							this.loadDataList();
						}
					});
				},
				cancel: () => {}
			});
		},

		/******加载系统业务日志列表**********/
		loadWorkLogDetail(){
			//打开模板选择弹窗
			this.globalDialog('workLogDetail',{
				props: {
					workType: this.workType
				}
			});
		},

		/******加载导入业务日志列表**********/
		loadImportLogDetail(){
			//打开模板选择弹窗
			this.globalDialog('importLogDetail', {
				props: {
					workType: this.workType
				}
			});
		},

		/******导入Excel数据**********/
		excelImport(){
			//打开模板选择弹窗
			this.globalDialog('excelImport',{
				props: {
				workType: this.workType
				}
			},this.importHandle);
		},

		/*********导入成功回调****************/
		importHandle(){
			setTimeout(() => {
				this.$refs.list.update();
			}, 300);
		}
	}
}
</script>

<style lang="stylus" scoped>
.custom-table {
	&-operate {
		>>> .m-operate {
			&[empty] + .m-operate,
			&:nth-child(1) {
				flex-grow: 1;
				width: 0;
				border-left-width: 1px;
			}

			&:nth-child(2) {
				padding-left: 8px;
			}

			&:nth-last-child(2) {
				padding-right: 0;
				border-right-width: 0;
			}
		}
	}

	>>> .c-upload-media-item,
	>>> .c-file-media {
		min-width: 32px;
		width: 32px;
		height: 32px;
		font-size: 20px;
	}

	>>> .c-upload-handle {
		display: none;
	}
}
</style>